<div class="mb-16">
  <div *ngIf="investigationBillTos?.length">
    <h6 class="mb-12">Additional Bill To:</h6>
    <div *ngFor="let item of investigationBillTos; let i = index" class="mb-12">
      <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(1,minmax(0,1fr))']"
        [cols]="item.isPrimary ? ['57%', '35%', '8%'] : ['45%', '22%', '28%', '5%']">
        <kendo-gridlayout-item>
          <div class="title-div">
            <p>
              {{ item.isPrimary ? 'Bill To (Primary):' : 'Bill To:' }}
            </p>
          </div>
          <ng-container *ngIf="!item.BillTo; else setBillTo">
            <div>
              <kendo-button kendoButton themeColor="primary" fillMode="link" size="medium" [disabled]="disabled" (click)="selectBillTo(i)">
                Select a Bill To
              </kendo-button>
            </div>
          </ng-container>
          <ng-template #setBillTo>
            <div class="align-baseline">
              <kendo-button *ngIf="!item.isPrimary && !disabled" kendoButton themeColor="primary" class="mr-2" fillMode="link" size="medium" (click)="removeBillTo(i)" [iconClass]="'fa-solid fa-circle-minus fa-lg'"></kendo-button>
              <kendo-gridlayout style="width: 100%;" [rows]="['auto']" [gap]="{rows: 5, cols: 0}" [cols]="['repeat(2,minmax(0,1fr))']">
                <kendo-gridlayout-item>
                  <span>
                    Contact
                  </span>
                  <p>
                    {{ item.BillTo | fullName }}
                  </p>
                </kendo-gridlayout-item>
                <kendo-gridlayout-item>
                  <span>
                    Company
                  </span>
                  <p>
                    {{ (item.BillToBranch?.Company?.name || 'N/A') + (item.BillToBranch?.name ? ' - ' + item.BillToBranch.name : '') }}
                  </p>
                </kendo-gridlayout-item>
              </kendo-gridlayout>
            </div>
          </ng-template>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="flex-center">
          <kendo-formfield>
            <kendo-label class="asterisk" text="Percentage"></kendo-label>
            <div class="numeric-text-suffix">
              <i class="fa-solid fa-percent"></i>
              <kendo-numerictextbox
                name="billToPercentage_{{i}}"
                #billToPercentage="ngModel"
                [(ngModel)]="item.percentage"
                [disabled]="disabled"
                (ngModelChange)="onPercentageChange()"
                [min]="0"
                [max]="100"
                [decimals]="2"
                format="n2"
                [autoCorrect]="false"
                placeholder="Enter percentage"
                fillMode="outline"
                required
              ></kendo-numerictextbox>
            </div>
            <kendo-formerror *ngIf="!billToPercentage?.valid && (billToPercentage?.dirty || billToPercentage?.touched)">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="billToPercentage?.errors?.required">Percentage cannot be left blank</span>
              <span *ngIf="billToPercentage?.errors?.minError">Percentage cannot be less than 0</span>
              <span *ngIf="billToPercentage?.errors?.maxError">Percentage cannot be more than 100</span>
            </kendo-formerror>
          </kendo-formfield>
        </kendo-gridlayout-item>
        <!-- Claim Number: hidden for primary (managed from TS), shown + required for non-primary -->
        <kendo-gridlayout-item *ngIf="!item.isPrimary" class="claim-action">
          <kendo-formfield class="form-field">
            <kendo-label class="asterisk" text="Claim Number"></kendo-label>
            <kendo-textbox
              name="billToClaimNumber_{{i}}"
              #billToClaimNumber="ngModel"
              [(ngModel)]="item.claimNumber"
              [disabled]="disabled"
              (ngModelChange)="emitChange()"
              placeholder="Enter claim number"
              fillMode="outline"
              required
            ></kendo-textbox>
            <kendo-formerror *ngIf="!billToClaimNumber?.valid && (billToClaimNumber?.dirty || billToClaimNumber?.touched)">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              <span *ngIf="billToClaimNumber?.errors?.required">Claim Number cannot be left blank</span>
            </kendo-formerror>
          </kendo-formfield>
          <span *ngIf="!item.isPrimary && !disabled" class="k-icon k-i-minus-outline" style="margin-top: 20px; cursor: pointer;" (click)="removeInvestigationBillTo(i)" title="Remove Bill To"></span>
        </kendo-gridlayout-item>
      </kendo-gridlayout>
    </div>
    <div *ngIf="isTotalInvalid" class="total-error">
      <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      <span>Total percentage must equal 100% (Current total: {{ totalPercentage }}%)</span>
    </div>
  </div>
  <button *ngIf="!disabled" kendoButton icon="plus-circle" themeColor="primary" fillMode="link" (click)="addInvestigationBillTo()">
    Add Additional Bill To
  </button>
  <p *ngIf="disabled && disabledMessage" class="mt-12">
    <i class="fa fa-info-circle" aria-hidden="true"></i>
    {{ disabledMessage }}
  </p>
</div>
